import ButtonGroup from "./ButtonGroup";
import LoadingModal from "@/components/LoadingModal";
import usePaymentInstrumentForm from "../paymentInstrument/usePaymentInstrumentForm";
import MessageGroup from "@/components/MessageGroup";
import PaymentInstrumentForm from "../paymentInstrument/PaymentInstrumentForm";
import { useState, useEffect } from "react";
import axios from "axios";
import { config } from "@/config";

export default function paymentForms({
    accountId,
    formType,
    setFormType,
    invoiceId,
    getInvoice,
    allowedPaymentMethods
}: {
    accountId: string,
    formType: string,
    setFormType: (formType: string) => void,
    invoiceId: string, getInvoice: (invoiceId: string) => void,
    allowedPaymentMethods: string[]
}) {
    const [paymentInstrumentId, setPaymentInstrumentId] = useState('')
    const { iframeRef, submit, clearForm, processing, errorMessage,
        successMessage, setProcessing, setErrorMessage } = usePaymentInstrumentForm(setPaymentInstrumentId)

    useEffect(() => {
        if (paymentInstrumentId) {
            payInvoice(paymentInstrumentId)
        }
    }, [paymentInstrumentId])

    async function payInvoice(paymentInstrumentId: string) {
        console.log("payment invoice", invoiceId, paymentInstrumentId, getPaymentMethod())
        try {
            const response = await axios.post(`${config.backendUrl}/invoices/pay`, {
                invoiceId,
                paymentInstrumentId,
                method: getPaymentMethod()
            })
            console.log("payment invoice response", response)
            getInvoice(invoiceId)
        } catch (err) {
            console.error("payment invoice error", err)
            setErrorMessage("Payment failed. Please try again.")
        } finally {
            setProcessing(false)
        }
    }

    function getPaymentMethod() {
        return formType === 'card-form' ? 'card' : 'ach'
    }
    return (
        <div className="relative bg-white p-4 rounded-lg shadow-sm">
            <LoadingModal loading={processing} />
            <div>
                <h2 className="text-md font-medium text-gray-800 mb-3">Payment Method</h2>
                <ButtonGroup allowedPaymentMethods={allowedPaymentMethods} formType={formType} setFormType={setFormType} />
                <PaymentInstrumentForm
                    iframeRef={iframeRef}
                    formType={formType}
                    submit={submit}
                    clearForm={clearForm}
                    accountId={accountId}
                />
                <MessageGroup
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                />
            </div>
        </div>
    );
}